import { tv } from "@ui/lib/tv";
import { cx } from "@ui/utils/cx";

/**
 * Shared chrome for the standard calendar family — StandardCalendar and
 * StandardRangeCalendar render the same root/grid/header/cell shell and only
 * differ in the range band and which cells count as the filled pill.
 */
export const calendar = tv({
  slots: {
    root: "inline-flex flex-col gap-3 p-5",
    grid: "w-[280px]",
    headerCell: "size-10 text-center font-medium text-base/6 text-neutral-600",
    cell: "group relative flex size-10 items-center justify-center p-0 disabled:pointer-events-none",
  },
});

export interface DayChipState {
  /** Filled green pill: the selected day (single) or a range endpoint. */
  isPill: boolean;
  /** Day inside a selected range (range calendar only) — hover deepens the band tint. */
  isInRange?: boolean;
  isDisabled: boolean;
  isUnavailable: boolean;
  isOutsideMonth: boolean;
}

/** The day number chip inside a calendar cell. */
export function dayChip({ isPill, isInRange = false, isDisabled, isUnavailable, isOutsideMonth }: DayChipState) {
  return cx(
    "relative flex size-8 items-center justify-center rounded-lg font-medium text-base/6",
    isPill
      ? "bg-green-500 text-white"
      : [
          "text-neutral-600",
          !isDisabled && !isUnavailable && !isInRange && "group-hover:bg-neutral-50",
          isInRange && "group-hover:bg-green-200",
          isUnavailable && "bg-neutral-50 text-neutral-500",
          isDisabled && "bg-neutral-50 text-neutral-500",
          isOutsideMonth && "bg-neutral-25 text-neutral-400",
        ],
  );
}
